import {
  RecognizeVipCursor,
  RecognizeVipFilter,
  RecognizeVipPage,
  RecognizeVipProfile,
} from "@redotech/redo-recognize-common/vip-profile";
import * as z from "zod";

export const getRecognizeVips = {
  name: "getRecognizeVips" as const,
  input: z.object({
    criterion: RecognizeVipFilter.nullable(),
    search: z.string().trim(),
    cursor: RecognizeVipCursor.nullable(),
  }),
  output: RecognizeVipPage,
};

export const getRecognizeVipOrders = {
  name: "getRecognizeVipOrders" as const,
  input: getRecognizeVips.input,
  output: z.array(
    RecognizeVipProfile.pick({
      id: true,
      orders: true,
      orderId: true,
      orderName: true,
      orderedAt: true,
      orderStats: true,
    }).extend({ customerSince: z.string().nullable() }),
  ),
};
